import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/screenata/approvals',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/workspaces/$workspaceId/screenata/policies',
      params: { workspaceId: params.workspaceId },
      replace: true,
    })
  },
})
